// extracted by mini-css-extract-plugin
module.exports = {"section":"contact_section__i_JCf","row":"contact_row__1nJYr","operator":"contact_operator__kzTtm","icon":"contact_icon__QfKnn","action":"contact_action__c5t4l"};